import map from 'lodash/map';
import each from 'lodash/each';
import union from 'lodash/union';
import reduce from 'lodash/reduce';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';

export const indexQuerylets = (querylets) => {
  const gatherFactIndexes = (factItem) => [
    // priority array format, each priority has its own array of indexes
    // higher priority
    [factItem.displayName.toLowerCase()],
    // lower priority
    map(factItem.children, ({ displayName }) => displayName.toLowerCase()),
  ];

  const gatherFieldIndexes = (fieldItem) => [
    // priority array format, but there is only one priority
    [fieldItem.displayName.toLowerCase()],
  ];

  const indexed = {};

  each(querylets, (item) => {
    if (item.type === 'database') {
      const indexedConstraintsItem = {
        _databaseData: { ...item, children: [] },
        _factsData: {},
        _factsIndexes: {},
        _fieldsIndexes: {},
      };

      eachHierarchy(item.children, (subItem) => {
        if (subItem.type === 'fact') {
          const factItem = subItem;

          indexedConstraintsItem._factsData[factItem.id] = factItem;
          indexedConstraintsItem._factsIndexes[factItem.id] = gatherFactIndexes(factItem);
        } else if (subItem.type === 'field') {
          const fieldItem = subItem;

          indexedConstraintsItem._fieldsIndexes[fieldItem.id] = gatherFieldIndexes(fieldItem);
        }
      });

      indexed[item.id] = indexedConstraintsItem;
    }
  });

  return indexed;
};

export const indexForms = (forms, indexedQuerylets) => {
  const getFactHighPriorityIndexesById = (factId) =>
    reduce(indexedQuerylets, (acc, indexed) => (indexed._factsIndexes[factId] ? union(acc, indexed._factsIndexes[factId][0]) : acc), []);

  const getFieldHighPriorityIndexesId = (fieldId) =>
    reduce(
      indexedQuerylets,
      (acc, indexed) => (indexed._fieldsIndexes[fieldId] ? union(acc, indexed._fieldsIndexes[fieldId][0]) : acc),
      []
    );

  const gatherFormIndexes = (formItem) => {
    // priority array format, each priority has its own array of indexes
    const indexesByPriority = [[formItem.displayName.toLowerCase()], [], []];

    eachHierarchy(
      formItem.content.facts,
      (fact) => {
        indexesByPriority[1] = union(indexesByPriority[1], getFactHighPriorityIndexesById(fact.id));

        each(fact.fields, (field) => {
          indexesByPriority[2] = union(indexesByPriority[2], getFieldHighPriorityIndexesId(field.id));
        });
      },
      null,
      { children: 'facts' }
    );

    return indexesByPriority;
  };

  const indexed = {};

  eachHierarchy(forms, (item) => {
    if (item.type === 'form') {
      const formItem = item;

      indexed[formItem.formId] = {
        _formData: formItem,
        _formIndexes: gatherFormIndexes(formItem),
      };
    }
  });

  return indexed;
};
